import { queryOptions } from "@tanstack/react-query";
import { fetchWorkspaces } from "../workspaces";
import type { AuthWorkspacesClient } from "../rpc/auth-workspaces";

/**
 * Keyed by user so a second sign-in never reads the previous account's listing. Sign-out
 * clears the whole cache as well; this key is the guard if a clear is ever missed.
 *
 * The answer carries which workspace is active, computed by the service from the session's
 * active team. Nothing else in the browser knows it: the session's organisation field names a
 * different object, and reading that is what left workspace selection broken.
 */
export function workspacesQueryOptions(userId: string, client?: AuthWorkspacesClient) {
  return queryOptions({
    queryKey: ["workspaces", userId] as const,
    queryFn: ({ signal }) => fetchWorkspaces(signal, 10000, client),
    retry: false,
  });
}
